/* eslint-disable @typescript-eslint/no-explicit-any */
export const registrations = [
    {
        name: 'Header',
        import: () => import('@stories/Widgets/Global/Header/Header'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Breadcrumbs',
        import: () => import('@stories/Widgets/Global/Breadcrumbs/Breadcrumbs'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'Footer',
        import: () => import('@stories/Widgets/Global/Footer/Footer'),
        config: {
            hydrate: 'lazy',
        },
    },
    // Banners
    {
        name: 'HomepageHero',
        import: () => import('@stories/Widgets/HomepageHero/HomepageHero'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'InnerPageHero',
        import: () => import('@stories/Widgets/InnerPageHero/InnerPageHero'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'ContentPageHero',
        import: () => import('@stories/Widgets/ContentPageHero/ContentPageHero'),
        config: {
            hydrate: 'always',
        },
    },
    // Widgets
    {
        name: 'Authors',
        import: () => import('@stories/Widgets/Authors/Authors'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'BrandCards',
        import: () => import('@stories/Widgets/BrandCards/BrandCards'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ContentCardListing',
        import: () => import('@stories/Widgets/ContentCardListing/ContentCardListing'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ContentCards',
        import: () => import('@stories/Widgets/ContentCards/ContentCards'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ContentEmbed',
        import: () => import('@stories/Widgets/ContentEmbed/ContentEmbed'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'CtaCards',
        import: () => import('@stories/Widgets/CtaCards/CtaCards'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'DownloadCards',
        import: () => import('@stories/Widgets/DownloadCards/DownloadCards'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'Faqs',
        import: () => import('@stories/Widgets/Faqs/Faqs'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ImageAndText',
        import: () => import('@stories/Widgets/ImageAndText/ImageAndText'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'InPageForm',
        import: () => import('@stories/Widgets/InPageForm/InPageForm'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ForgottenPassword',
        import: () => import('@stories/Widgets/SignUpInForms/ForgottenPassword/ForgottenPassword'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'JoinCtaCard',
        import: () => import('@stories/Widgets/JoinCtaCard/JoinCtaCard'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'LogInSignUp',
        import: () => import('@stories/Widgets/SignUpInForms/LogInSignUp/LogInSignUp'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'LogoList',
        import: () => import('@stories/Widgets/LogoList/LogoList'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'Media',
        import: () => import('@stories/Widgets/Media/Media'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'PeopleBanner',
        import: () => import('@stories/Widgets/PeopleBanner/PeopleBanner'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'PeopleCards',
        import: () => import('@stories/Widgets/PeopleCards/PeopleCards'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'PopUpForm',
        import: () => import('@stories/Widgets/PopUpForm/PopUpForm'),
        config: {
            hydrate: 'always',
        },
    },
    {
        name: 'PortalForms',
        import: () => import('@stories/Widgets/PortalForms/PortalForms'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'PortalTabs',
        import: () => import('@stories/Widgets/PortalTabs/PortalTabs'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'Pricing',
        import: () => import('@stories/Widgets/Pricing/Pricing'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ResetPassword',
        import: () => import('@stories/Widgets/SignUpInForms/ResetPassword/ResetPassword'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'RichText',
        import: () => import('@stories/Widgets/RichText/RichText'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'SearchResults',
        import: () => import('@stories/Widgets/SearchResults/SearchResults'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'SharePrintSave',
        import: () => import('@stories/Widgets/SharePrintSave/SharePrintSave'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'SignUp',
        import: () => import('@stories/Widgets/SignUpInForms/SignUp/SignUp'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'SplitContentCard',
        import: () => import('@stories/Widgets/SplitContentCard/SplitContentCard'),
        config: {
            hydrate: 'in-view',
        },
    },
    {
        name: 'StatsCallOut',
        import: () => import('@stories/Widgets/StatsCallOut/StatsCallOut'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'Table',
        import: () => import('@stories/Widgets/Table/Table'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'TableOfContents',
        import: () => import('@stories/Widgets/TableOfContents/TableOfContents'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'USP',
        import: () => import('@stories/Widgets/Usp/Usp'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'TestimonialCarousel',
        import: () => import('@stories/Widgets/TestimonialCarousel/TestimonialCarousel'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'BrandCardListing',
        import: () => import('@stories/Widgets/BrandCardListing/BrandCardListing'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'RestrictedContent',
        import: () => import('@stories/Widgets/RestrictedContent/RestrictedContent'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'PeopleBanner',
        import: () => import('@stories/Widgets/PeopleBanner/PeopleBanner'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'ScrollArrow',
        import: () => import('@stories/Widgets/Global/ScrollArrow/ScrollArrow'),
        config: {
            hydrate: 'lazy',
        },
    },
    {
        name: 'MediaGrid',
        import: () => import('@stories/Widgets/MediaGrid/MediaGrid'),
        config: {
            hydrate: 'lazy',
        },
    },
];
